import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { fetchRecipientsIfNeeded } from 'messaging/actions/recipient';
import { fetchThreadsIfNeeded } from 'messaging/actions/thread';
import PageLoader from 'common/components/PageLoader';

const mapStateToProps = state => {
  const { threads, recipients, tags } = state.messaging;

  return {
    isFetching: threads.isFetching && recipients.isFetching && tags.isFetching,
  };
};
const mapDispatchToProps = dispatch => ({
  fetchRecipients: () => dispatch(fetchRecipientsIfNeeded()),
  fetchThreads: () => dispatch(fetchThreadsIfNeeded()),
});
class CoreLayout extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    isFetching: PropTypes.bool,
    fetchRecipients: PropTypes.func.isRequired,
    fetchThreads: PropTypes.func.isRequired,
  };

  // TODO: Fetch them all in one action
  componentWillMount() {
    this.props.fetchRecipients();
    this.props.fetchThreads();
  }

  render() {
    const { isFetching, children } = this.props;

    if (isFetching) {
      return <PageLoader title="Chargement de la messagerie" />;
    }

    return (
      <div style={{ height: '100%' }}>
        <div className="ui secondary pointing menu">
          <Link to="mailbox" className="item" activeClassName="active">
            Boîte de réception
          </Link>
          <Link to="diffusion" className="item" activeClassName="active">
            Liste de diffusion
          </Link>
        </div>
        {children}
      </div>
    );
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), pure)(
  CoreLayout
);



// WEBPACK FOOTER //
// ./src/modules/messaging/layouts/CoreLayout.js